import { render, staticRenderFns } from "./text-templates-grid.vue?vue&type=template&id=8d50871a&scoped=true&"
import script from "./text-templates-grid.ts?vue&type=script&lang=ts&"
export * from "./text-templates-grid.ts?vue&type=script&lang=ts&"
import style0 from "./text-templates-grid.scss?vue&type=style&index=0&id=8d50871a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d50871a",
  null
  
)

export default component.exports